import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "no-data-icon",
  "use": "no-data-icon-usage",
  "viewBox": "0 0 34 34",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 34\" id=\"no-data-icon\"><path fill=\"#1c1b1b\" d=\"M15.333 18.667h3.334v-10h-3.334zm0 6.666h3.334V22h-3.334zM3.667 17C3.667 9.636 9.637 3.667 17 3.667c7.364 0 13.333 5.97 13.333 13.333 0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.333-5.97-13.333-13.333zm30 0C33.667 7.795 26.205.333 17 .333 7.795.333.333 7.795.333 17c0 9.205 7.462 16.667 16.667 16.667 9.205 0 16.667-7.462 16.667-16.667z\" opacity=\".4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol